import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { hideNativeSplash } from './capacitor/splash';
import { registerBackButton } from './capacitor/backButton';

// The native splash does not autohide (capacitor.config.ts), so App takes it
// down once auth resolves. This is the backstop for the case where that never
// happens: a render crash, or auth hanging on a dead network. Without it the
// user would be left staring at a splash with no way forward. Armed here
// rather than inside React so a failure to mount cannot disarm it. hide() is
// idempotent, so the normal path racing it is harmless.
setTimeout(hideNativeSplash, 5000);

registerBackButton();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.unregister();
